/** Holi Festival Deals Images */
// Hero Banner
import heroBanner from '../../../assets/HoliFestivalDeals/heroBanner.webp';

import bgImage from '../../../assets/HoliFestivalDeals/bgImage.webp';

// categories
import food from '../../../assets/HoliFestivalDeals/categories/food.webp';
import travel from '../../../assets/HoliFestivalDeals/categories/travel.webp';
import shopping from '../../../assets/HoliFestivalDeals/categories/shopping.webp';
import electronics from '../../../assets/HoliFestivalDeals/categories/electronics.webp';
import entertainment from '../../../assets/HoliFestivalDeals/categories/entertainment.webp';

// spotlight brands
import spotlight_brand_1 from '../../../assets/HoliFestivalDeals/spotlightBrands/Swiggy.webp';
import spotlight_brand_2 from '../../../assets/HoliFestivalDeals/spotlightBrands/JioMart.webp';
import spotlight_brand_3 from '../../../assets/HoliFestivalDeals/spotlightBrands/Instamart.webp';
import spotlight_brand_4 from '../../../assets/HoliFestivalDeals/spotlightBrands/AbhiBus.webp';
import spotlight_brand_5 from '../../../assets/HoliFestivalDeals/spotlightBrands/Eatsure.webp';
import spotlight_brand_6 from '../../../assets/HoliFestivalDeals/spotlightBrands/Redbus.webp';
import spotlight_brand_7 from '../../../assets/HoliFestivalDeals/spotlightBrands/EMT.webp';
import spotlight_brand_8 from '../../../assets/HoliFestivalDeals/spotlightBrands/TheManCompany.webp';

// other Brands
import ConfirmTkt from '../../../assets/HoliFestivalDeals/otherBrands/ConfirmTkt.svg';
import BookMyShow from '../../../assets/HoliFestivalDeals/otherBrands/BookMyShow.svg';
import Neemans from '../../../assets/HoliFestivalDeals/otherBrands/Neemans.svg';
import Zeeraki from '../../../assets/HoliFestivalDeals/otherBrands/Zeeraki.svg';
import Netmeds from '../../../assets/HoliFestivalDeals/otherBrands/Netmeds.svg';
import JustHerbs from '../../../assets/HoliFestivalDeals/otherBrands/JustHerbsv2.svg';

// App Exclusive
import TwidStars from '../../../assets/HoliFestivalDeals/appExclusive/TwidStars.webp';
import TwidScanAndPay from '../../../assets/HoliFestivalDeals/appExclusive/TwidScanAndPay.webp';
import Ixigo from '../../../assets/HoliFestivalDeals/appExclusive/Ixigo.webp';

export default {
  bgImage,
  heroBanner,
  categories: {
    food,
    travel,
    shopping,
    electronics,
    entertainment,
  },
  holiFestivalDealsSpotlightBrands: {
    spotlight_brand_1,
    spotlight_brand_2,
    spotlight_brand_3,
    spotlight_brand_4,
    spotlight_brand_5,
    spotlight_brand_6,
    spotlight_brand_7,
    spotlight_brand_8,
  },
  otherBrands: {
    ConfirmTkt,
    BookMyShow,
    Neemans,
    Zeeraki,
    Netmeds,
    JustHerbs,
  },
  appExclusive: {
    TwidStars,
    TwidScanAndPay,
    Ixigo,
  },
};
